/**
 * A function to scall all *.json file in vue (TODO we will probably move this
 * to the backend).
 */
function loadResources() {
  const locales = require.context('../../assets/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = key.split('/')[1];
      var namespace = matched[1];
      if (locale in messages) {
        messages[locale][namespace] = locales(key);
      } else {
        messages[locale] = {};
        messages[locale][namespace] = locales(key);
      }
    }
  });
  return messages;
}

export default loadResources;
